import { __makeTemplateObject } from "tslib";
import { css } from 'styled-components';
export var normal = function (props) { var _a, _b; return (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.weights) === null || _b === void 0 ? void 0 : _b[0]; };
export var bold = function (props) { var _a, _b; return (_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.weights) === null || _b === void 0 ? void 0 : _b[1]; };
export var px = function (n) { return (typeof n === 'number' ? n + 'px' : n); };
export var monospace = function (props) {
    return props.monospace
        ? css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t\t\tfont-family: ", ";\n\t\t  "], ["\n\t\t\t\tfont-family: ", ";\n\t\t  "])), props.theme.monospace) : null;
};
export var emphasized = function (props) {
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\theight: ", ";\n\t"], ["\n\t\theight: ",
        ";\n\t"])), px(props.emphasized ? props.theme.space[5] : props.theme.space[4]));
};
var templateObject_1, templateObject_2;
